import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter, Route, Routes } from "react-router";
import { ToastContainer } from "react-toastify";

import { Dev } from "pages/dev/dev";
import { Home } from "pages/home";
import { MyCerts } from "pages/my-certs";
import { ProfilePage } from "pages/profile";
import { Layout } from "pages/ui/layout";
import { HolderProvider } from "shared/providers/holder/provider";
import { RqProvider } from "shared/providers/rq/provider";

import { Fallback } from "./fallback";
import { DesktopGuard } from "./guard/desktop-guard";
import "./index.css";

export const App = () => {
  return (
    <ErrorBoundary
      fallbackRender={({ error, resetErrorBoundary }) => (
        <Fallback error={error} resetErrorBoundary={resetErrorBoundary} />
      )}
    >
      <DesktopGuard>
        <RqProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route index path="/" element={<Home />} />
                <Route path="/dev" element={<Dev />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route element={<HolderProvider />}>
                  <Route path="/my-certs" element={<MyCerts />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
          <ToastContainer
            closeButton={false}
            icon={false}
            hideProgressBar
            position="top-center"
          />
        </RqProvider>
      </DesktopGuard>
    </ErrorBoundary>
  );
};
